export const dutyChanges = [
    {projectName: 'Shift Management'},
    {projectName: 'Shift List'},
    {projectName: 'Roster Assign'},
    {projectName: 'Roster List'},
    {projectName: 'Attendance Dashboard'},
]
export const houseKeeping = [
    {projectName: 'House Keeping'},
    {projectName: 'Room Cleaning'},
    {projectName: 'Assign Room Cleaning'},
    {projectName: 'Laundry Product List'},
    {projectName: 'Payment'},
]
export const restaurant = [
    {projectName: 'Restaurant'},
    {projectName: 'POS Invoice'},
    {projectName: 'Order List'},
    {projectName: 'Cancel Order'},
    {projectName: 'Manage Category'},
    {projectName: 'Add Category'},
    {projectName: 'Category List'},
]
export const paymentSetting = [
    {projectName: 'Payment Setting'},
    {projectName: 'Payment Method List'},
    {projectName: 'Add Payment Method'},
    {projectName: 'Payment Setup'},
]